import styled from "styled-components";

export const PayrollreportWrapper = styled("div")(() => {
  return {
    position: "relative",
    padding: 0,
    display: "grid",
    gap: "1.5rem",
    "& .payment-modal": {
      position: "fixed",
      top: "50%",
      left: "50%",
      height: "auto",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#FFFFFF",
      padding: "calc(var(--cardPadding) * 1)",
      borderRadius: "1rem",
      boxShadow: "0px 20px 24px -4px #10182814",
      "& .payment-form": {
        alignItems: "unset",
        justifyContent: "unset",
        padding: "unset",
      },
      "@media screen and (max-width: 425px)": {
        top: "50%",
        left: "50%",
        right: 0,
        bottom: 0,
        transform: "translate(-50%, -50%)",
        borderRadius: "0.9rem",
        width: "85%",
      },
    },
    "& .error-box": {
      padding: "0",
      "& p": {
        marginBlock: 0,
      },
    },
    "& .export-button-area": {
      display: "flex",
      justifyContent: "flex-end",
    },
  };
});

export const PayrollreportFilterCard = styled("section")(() => {
  return {
    "--filter-control-height": "3rem",
    border: "1px solid #e5e7eb",
    borderRadius: "0.85rem",
    backgroundColor: "var(--color-primary-hover)",
    padding: "1rem",
    display: "grid",
    gap: "1rem",
    "& .filter-title": {
      margin: 0,
      display: "inline-flex",
      alignItems: "center",
      gap: "0.45rem",
      fontFamily: "Poppins",
      color: "var(--color-text-light)",
      fontSize: "0.78rem",
      letterSpacing: "0.07em",
      textTransform: "uppercase",
      fontWeight: 700,
    },
    "& .filter": {
      display: "grid",
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
      gridTemplateAreas: `
        "start-year start-month export"
        "end-year end-month ."
      `,
      alignItems: "end",
      gap: "1rem",
      "& fieldset": {
        overflow: "hidden",
      },
      "& > fieldset:nth-of-type(1)": {
        gridArea: "start-year",
      },
      "& > fieldset:nth-of-type(2)": {
        gridArea: "start-month",
      },
      "& > fieldset:nth-of-type(3)": {
        gridArea: "end-year",
      },
      "& > fieldset:nth-of-type(4)": {
        gridArea: "end-month",
      },
      "& .export-button-area": {
        gridArea: "export",
        width: "100%",
        justifyContent: "stretch",
        alignSelf: "end",
      },
      "& label": {
        fontFamily: "Poppins",
        fontWeight: 600,
        fontSize: "0.8rem",
        color: "var(--color-primary)",
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        marginBottom: "0.45rem",
        display: "inline-block",
      },
      "& select": {
        padding: "0.7rem 0.8rem",
        minHeight: "var(--filter-control-height)",
        borderRadius: "0.45rem",
        border: "1px solid #d9dee7",
        fontWeight: "400",
        color: "var(--color-text)",
        backgroundColor: "var(--color-neutral)",
        "&:focus": {
          outline: "none",
          border: "none",
        },
      },
      "@media screen and (max-width: 768px)": {
        gridTemplateColumns: "1fr",
        gridTemplateAreas: `
          "start-year"
          "start-month"
          "end-year"
          "end-month"
          "export"
        `,
      },
    },
    "& .export-button-area > div": {
      display: "flex",
      height: "100%",
      width: "100%",
    },
    "& .export-table-btn": {
      minHeight: "var(--filter-control-height)",
      height: "var(--filter-control-height)",
      display: "inline-flex",
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
      padding: "0 1rem",
      borderRadius: ".45rem",
      transition: "background-color 0.2s ease",
      "&:hover": {
        backgroundColor: "#1f5620",
      },
    },
  };
});

export const PayrollreportTableCard = styled("div")(() => {
  return {
    border: "1px solid #e5e7eb",
    borderRadius: "0.9rem",
    overflow: "hidden",
    backgroundColor: "var(--color-neutral)",
    display: "grid",
    gap: "0.75rem",
    "& .payrollreport-button": {
      borderBottom: "1px solid #e5e7eb",
      "&:last-child": {
        borderBottom: "none",
      },
      "&.is-open .payrollreport-accordion-trigger": {
        backgroundColor: "var(--color-primary-hover)",
      },
    },
    "& .payrollreport-accordion-trigger": {
      width: "100%",
      minHeight: "4rem",
      padding: "0.9rem 1.1rem",
      border: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "1rem",
      backgroundColor: "var(--color-neutral)",
      color: "var(--color-text)",
      cursor: "pointer",
      textAlign: "left",
      transition: "background-color 0.18s ease",
      "&:hover": {
        backgroundColor: "var(--color-primary-hover)",
      },
      "&:focus-visible": {
        outline: "2px solid var(--color-secondary)",
        outlineOffset: "-2px",
      },
    },
    "& .payrollreport-accordion-title": {
      display: "flex",
      flexDirection: "column",
      fontSize: "0.9rem",
      gap: "0.2rem",
      fontWeight: 700,
    },
    "& .payrollreport-accordion-date": {
      color: "var(--color-text-light)",
      fontSize: "0.85rem",
      fontWeight: 500,
    },
    "& .payrollreport-accordion-action": {
      display: "inline-flex",
      alignItems: "center",
      gap: "0.65rem",
      color: "var(--color-primary)",
      fontSize: "0.82rem",
      fontWeight: 700,
      whiteSpace: "nowrap",
    },
    "& .payrollreport-chevron": {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: "1.7rem",
      height: "1.7rem",
      borderRadius: "50%",
      backgroundColor: "var(--color-primary)",
      color: "#FFFFFF",
      fontSize: "1.15rem",
      lineHeight: 1,
    },
    "& .payrollreport-accordion-panel": {
      borderTop: "1px solid #e5e7eb",
      backgroundColor: "#FFFFFF",
    },
    "& .payrollreport-table": {
      overflowX: "auto",
      borderRadius: "0.7rem",
      border: "1px solid #edf1f6",
      backgroundColor: "#FFFFFF",
    },
    "& .payrollreport-table table": {
      width: "100%",
      borderCollapse: "separate",
      borderSpacing: 0,
      minWidth: "950px",
    },
    "& .payrollreport-table th": {
      backgroundColor: "var(--color-primary-hover)",
      color: "var(--color-primary)",
      borderBottom: "1px solid #e5e7eb",
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      padding: "0.8rem 1rem",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      fontSize: "0.8rem",
      minWidth: "unset",
      fontWeight: 700,
      textAlign: "left",
    },
    "& .payrollreport-table tbody": {
      "& tr": {
        borderBottom: "1px solid #e5e7eb",
        "&:last-child": {
          borderBottom: "none",
        },
        "&:hover": {
          backgroundColor: "var(--color-background)",
        },
      },
      "& td": {
        border: "none",
        borderBottom: "1px solid #edf1f6",
        color: "var(--color-text)",
        padding: "0.95rem 1rem",
        minWidth: "unset",
        fontSize: "0.88rem",
        verticalAlign: "middle",
      },
      "& .employee-cell": {
        display: "flex",
        alignItems: "center",
        gap: "0.75rem",
        "& .avatar": {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "34px",
          height: "34px",
          borderRadius: "50%",
          background:
            "linear-gradient(135deg, var(--color-tertiary) 0%, var(--color-tertiary) 50%, var(--color-secondary) 100%)",
          color: "#FFFFFF",
          fontWeight: 700,
          fontSize: ".72rem",
          flexShrink: 0,
        },
        "& .employee-meta": {
          display: "flex",
          flexDirection: "column",
          gap: "0.25rem",
        },
        "& .employee-name": {
          fontWeight: 600,
          color: "var(--color-text)",
        },
        "& .employee-caption": {
          fontSize: "12px",
          color: "var(--color-text-light)",
        },
      },
      "& .tax-id": {
        display: "inline-flex",
        padding: "0.2rem 0.55rem",
        borderRadius: "999px",
        fontSize: "12px",
        fontWeight: 700,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "var(--color-text)",
      },
      "& .payrollreport-badge": {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0.2rem 0.55rem",
        borderRadius: "999px",
        fontSize: "12px",
        fontWeight: 700,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        backgroundColor: "#E8F5E9",
        color: "var(--color-primary)",
      },
    },
    "& .payrollreport-summary": {
      display: "grid",
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
      borderBottom: "1px solid #e5e7eb",
      padding: "1rem",
      "& .summary-item": {
        textAlign: "center",
        color: "var(--color-text)",
        fontWeight: 600,
        fontSize: "0.88rem",
      },
    },
    "& .payrollreport-button-area": {
      display: "flex",
      justifyContent: "flex-end",
      padding: "1rem",
    },
    "& .remit-payroll-btn": {
      backgroundColor: "var(--color-primary)",
      color: "var(--color-neutral)",
      border: "1px solid #e5e7eb",
      borderRadius: "0.45rem",
      fontSize: "0.88rem",
      fontWeight: 600,
      cursor: "pointer",
      padding: "0.7rem 1.2rem",
      transition: "all 0.2s ease",
      height: "2.75rem",
      width: "fit-content",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:hover:not(:disabled)": {
        backgroundColor: "#1f5620",
      },
      "&:disabled": {
        opacity: 0.5,
        cursor: "not-allowed",
      },
    },
  };
});
